import type { ReactNode } from "react";

import classes from "./MediaGrid.module.css";

export interface MediaGridProps {
  children: ReactNode;
  /** A fixed column count (the library's setting); by default, as many 240px columns as fit. */
  columns?: number;
  /** Names the grid for a screen reader, as a group. */
  label?: string;
}

/** Media cards in a grid with 16px gaps (design-system.md 3.3, 3.5). */
export function MediaGrid({ children, columns, label }: MediaGridProps) {
  const template =
    columns === undefined ? undefined : `repeat(${columns}, minmax(0, 1fr))`;
  return (
    <div
      className={classes.grid}
      style={template === undefined ? undefined : { gridTemplateColumns: template }}
      role={label === undefined ? undefined : "group"}
      aria-label={label}
    >
      {children}
    </div>
  );
}
